import * as types from "../actions/ActionTypes.js";
import ProductFilter from "../utilities/OrganizationProductFilter";

export const getInitialState = () => (
    {
        users: [],
        products: [],
        productRoles: [],
        user: null,
        newPassword: undefined,
        organizationProducts: []
    });

const personnelReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_USERS_BY_ORG_SUCCEEDED:
        return Object.assign({}, state, { users: action.users });
    case types.GET_ORGANIZATION_BY_ID_SUCCEEDED: {
        const products = ProductFilter.filterProductsJS(action.organization.products);
        return Object.assign({}, state, { products: products, organizationProducts: action.organization.products });
    }
    case types.GET_ROLES_BY_PRODUCT_ID_SUCCEEDED: {
        const newRole = {
            productId: action.productId,
            roles: action.roles,
            productName: action.productName
        };
        const availableRoles = [...state.productRoles, newRole];
        return Object.assign({}, state, { productRoles: availableRoles });
    }
    case types.SET_USER: {
        const user = action.user.createCopy();
        return Object.assign({}, state, { user: user, newPassword: undefined });
    }
    case types.SET_FIELD: {
        const user = state.user.createCopy();
        const field = action.fieldName;
        user[field] = action.value;
        return Object.assign({}, state, { user: user });
    }
    case types.USER_INVALID: {
        const user = state.user.createCopy();
        user.isValid = false;
        return Object.assign({}, state, { user: user });
    }
    case types.USER_SELECT_PRODUCT: {
        const user = state.user.createCopy();
        const product = state.productRoles.find(p => p.productId === action.productId);

        const defaultRole = user.getDefaultProductRole(state.productRoles, action.productId);
        const userProduct = {
            productId: product.productId,
            productName: product.productName,
            assigned: action.checked
        };
        if (defaultRole) {
            userProduct.roleId = defaultRole.id;
            userProduct.roleName = defaultRole.name;
        }

        user._assignUserProduct(userProduct, state.organizationProducts);
        return Object.assign({}, state, { user: user });
    }
    case types.USER_SELECT_ROLE: {
        const user = state.user.createCopy();
        const productIndex = user.userProducts.findIndex(p => p.productId === action.productId);
        if (productIndex > -1) {
            user.userProducts[productIndex].roleId = action.roleId;
            user.userProducts[productIndex].roleName = action.roleName;
        }
        return Object.assign({}, state, { user: user });
    }
    case types.RESET_USER_PASSWORD_SUCCEEDED:
        return Object.assign({}, state, { newPassword: action.newPassword });
    case types.SET_USER_ACTIVE: {
        const user = state.user.createCopy();
        user.isActive = action.isActive;
        return Object.assign({}, state, { user: user, users: state.users });
    }
    case types.CREATE_USER_SUCCEEDED:
        var user = action.user;
        user.newPassword = action.newPassword;
        return Object.assign({}, state, { user: user });
    default:
        return state;
    }
};


export default personnelReducer;
